import * as React from 'react';
import styled from 'styled-components';
import AFMCSeal from './AFMCSeal';

const Wrapper = styled.div`
    margin: ${p => (p.smallTop ? 50 : 100)}px 0 100px 0;
`;

const Title = styled.h3`
    margin-top: 0;
`;

const Picture = styled.img.attrs(() => ({
    className: 'z-depth-2',
}))`
    border-radius: 5px;

    @media only screen and (max-width: 993px) {
        margin-bottom: 20px;
    }

    @media only screen and (min-width: 993px) {
        margin-right: 30px;
    }
`;

const PictureWrapper = styled.div`
    @media only screen and (max-width: 993px) {
        text-align: center;
    }

    @media only screen and (min-width: 993px) {
        display: flex;
        align-items: center;
        margin-bottom: 50px;
    }
`;

const CenterImage = styled.div`
    @media only screen and (max-width: 993px) {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
`;

const Person = ({image, title, credentials, AFMCId, children, smallTop}) => (
    <Wrapper smallTop={smallTop}>
        <PictureWrapper>
            <CenterImage>
                <Picture src={image} alt={title} width="250" />
            </CenterImage>
            <div>
                {AFMCId && <AFMCSeal id={AFMCId} />}
                <Title>{title}</Title>
            </div>
        </PictureWrapper>
        <em>{credentials}</em>
        {children}
    </Wrapper>
);

export default Person;
